import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M60 80q0-40 40-50 40 10 40 50v30q20-10 28 20-6 30-28 20v18q-40 10-80 0v-18q-22 10-28-20 8-30 28-20Z" }, null, -1),
    _createElementVNode("ellipse", {
      cx: "100",
      cy: "118",
      fill: "var(--mc-avatar)",
      rx: "22",
      ry: "14"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "100",
      cy: "118",
      r: "9"
    }, null, -1)
  ]))]))
}
export default { render: render }